import React from "react";

const VSpace: React.FC = () => {
  return <div className="mt-2" />;
};

export default VSpace;
